import { Dispatch, SetStateAction } from 'react';

interface onMinusThreeMonthProps {
  calStartYear: string;
  calStartMonth: string;
  calStartDate: string;
  setStartDate: Dispatch<SetStateAction<any>>;
}

// MEMO: 3개월씩 감소
export const onMinusThreeMonth = ({
  calStartYear,
  calStartMonth,
  calStartDate,
  setStartDate,
}: onMinusThreeMonthProps) => {
  let targetMonth = Number(calStartMonth);
  let targetYear = Number(calStartYear);
  // const targetDate = Number(calStartDate);
  const targetDate = 1;

  if (targetMonth > 3) {
    targetMonth = targetMonth - 3;
  } else if (targetMonth === 3) {
    targetMonth = 12;
    targetYear = targetYear - 1;
  } else {
    targetMonth = 12 - (3 - targetMonth);
    targetYear = targetYear - 1;
  }

  setStartDate(new Date(`${targetYear}-${targetMonth}-${targetDate}`));
};
